import { createFileRoute } from '@tanstack/react-router'
import { ParticipantList } from '@/features/marking/participant-list'

export const Route = createFileRoute(
  '/_authenticated/marking/list-participant',
)({
  component: ParticipantList,
})
